import { Component, Input } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-teammembers',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './teammembers.component.html',
  styleUrl: './teammembers.component.scss'
})
export class TeammembersComponent {
  @Input() teamKey: string = ""
  @Input() organizationKey: string = ""
  members: any[] = []
  isLoading: boolean = true

  constructor(private firestore: FirestoreService) {

  }

  ngAfterViewInit() {
    if (this.organizationKey != "" && this.teamKey != "") {
      this.getMembers()
    }
  }

  async getMembers() {
    this.isLoading = true
    await this.firestore.getTeamMembers(this.organizationKey, this.teamKey).then(members => {
        this.members = members
        this.isLoading = false
    })
  }

}
